export default __webpack_public_path__ + "static/media/fastclix_lancets.cb7f4432.webp";